import { Checkbox, FormControlLabel } from "@mui/material";
import * as React from "react";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { Base } from "ui/Scripts/source/framework/base";
import { TaskTypeClassTextSize } from "ui/Scripts/source/models/enums";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { FormFieldMargin } from "./TaskDynamicForm.styles";
import { getFormFieldTitleColor, getFormFieldTitleStr } from "./TaskDynamicFormFieldUtils";

export interface ITaskDynamicFormBooleanProp {
    isReadOnly: boolean;
    colIsReadOnly: boolean;
    showFieldName: boolean;
    showFieldNameColor: string;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export const getCheckBoxSizeSx = (className: string): any => {
    let classnames = className ?? "";
    if (!classnames) return null;
    classnames = " " + classnames + " ";
    if (classnames.indexOf(" " + TaskTypeClassTextSize.Small + " ") > -1) return { "& .MuiSvgIcon-root": { fontSize: 16 } };
    if (classnames.indexOf(" " + TaskTypeClassTextSize.Medium + " ") > -1) return { "& .MuiSvgIcon-root": { fontSize: 20 } };
    if (classnames.indexOf(" " + TaskTypeClassTextSize.Large + " ") > -1) return { "& .MuiSvgIcon-root": { fontSize: 30 } };
    if (classnames.indexOf(" " + TaskTypeClassTextSize.Extra + " ") > -1) return { "& .MuiSvgIcon-root": { fontSize: 36 } };
    return null;
};

export class TaskDynamicFormBoolean extends React.Component<ITaskDynamicFormBooleanProp, {}> {
    handleCheckboxClickBoolean = (checked: boolean) => {
        const newValue = new TaskDataRowCol(this.props.taskDataRowCol);
        newValue.valueNbr = checked ? 1 : 0;
        newValue.valueStr = checked ? "1" : "0";
        this.props.onChange(newValue);
    };

    render() {
        const props = this.props;
        const typeCol = props.taskTypeCol;
        const dataCol = props.taskDataRowCol;
        return (
            <FormField title="" required={typeCol.required && !props.isReadOnly} margin={FormFieldMargin}>
                <FormControlLabel
                    control={
                        <Checkbox
                            title={getFormFieldTitleStr(typeCol, props.showFieldName)}
                            name={typeCol.field}
                            disabled={props.colIsReadOnly || props.isReadOnly}
                            style={{ paddingBottom: 0, paddingTop: 0 }}
                            sx={getCheckBoxSizeSx(typeCol.class)}
                            checked={Base.strToBool(dataCol?.valueStr)}
                            onChange={(_e, checked) => this.handleCheckboxClickBoolean(checked)}
                        />
                    }
                    label={getFormFieldTitleStr(typeCol, props.showFieldName)}
                    sx={{ color: getFormFieldTitleColor(props.showFieldName, props.showFieldNameColor) }}
                    className="checkbox"
                />
            </FormField>
        );
    }
}